import React from "react";
import { useHistory } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import "./home-landing.css";

const IMG = (folder, file) => `${process.env.PUBLIC_URL || ""}/images/${folder}/${file}.png`;
const DEMO_VIDEO = "/images/home.mp4?v=20260330_1";

// Floating artwork around the headline. Each tile drifts on its own timing.
const TILES = [
  { id: "book", src: IMG("collapsed-blue", "03-read-listen-grow"), cls: "lh-tile--book", alt: "Open book with letters A, B and C" },
  { id: "tower", src: IMG("expanded", "02-build-balance-discover"), cls: "lh-tile--tower", alt: "Stacked blocks" },
  { id: "easel", src: IMG("expanded", "01-paint-explore-create"), cls: "lh-tile--easel", alt: "Easel with a painting" },
  { id: "leaf", src: IMG("expanded", "04-explore-world-outside"), cls: "lh-tile--leaf", alt: "Leaf" },
  { id: "drum", src: IMG("expanded", "05-rhythm-song-movement"), cls: "lh-tile--drum", alt: "Drum" },
];

const HomeHero = () => {
  const history = useHistory();

  return (
    <section className="lh-hero" aria-label="Montestory">
      <div className="lh-hero__inner">
        <p className="lh-kicker">
          <span className="lh-kicker__dot" aria-hidden />
          Built exclusively for Montessori schools
        </p>

        <h1 className="lh-title">
          Hands-on learning{" "}
          <span
            className="lh-chip lh-chip--art"
            style={{ backgroundImage: `url("${IMG("expanded", "01-paint-explore-create")}")` }}
            aria-hidden
          />
          <br />
          meets calm{" "}
          <span
            className="lh-chip lh-chip--leaf"
            style={{ backgroundImage: `url("${IMG("expanded", "04-explore-world-outside")}")` }}
            aria-hidden
          />{" "}
          operations.
        </h1>

        <p className="lh-lead">
          One joyful workspace for your classrooms, office, and families, so guides spend less time on
          paperwork and more time following the child.
        </p>

        <div className="lh-cta">
          <button type="button" className="lh-btn lh-btn--primary" onClick={() => history.push("/montessori/schoolregistration")}>
            Start your free trial <ArrowForwardIcon fontSize="small" />
          </button>
          <a className="lh-btn lh-btn--ghost" href={DEMO_VIDEO} target="_blank" rel="noopener noreferrer">
            <PlayArrowIcon fontSize="small" /> Watch demo
          </a>
        </div>
      </div>

      <div className="lh-stage" aria-hidden="true">
        {TILES.map(({ id, src, cls }) => (
          <span key={id} className={`lh-tile ${cls}`} style={{ backgroundImage: `url("${src}")` }} />
        ))}
        <span className="lh-note lh-note--left">
          <i /> Observation saved
        </span>
        <span className="lh-note lh-note--right">
          <i /> Shared with family
        </span>
        <span className="lh-badge">
          <svg viewBox="0 0 120 120" className="lh-badge__ring">
            <defs>
              <path id="lhRing" d="M60,60 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0" />
            </defs>
            <text>
              <textPath href="#lhRing">FREE TRIAL · FREE TRIAL · FREE TRIAL · </textPath>
            </text>
          </svg>
          <b>30</b>
          <small>days</small>
        </span>
      </div>
    </section>
  );
};

export default HomeHero;
